import React, { useState } from "react";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";
import "../styles/AppStyles.css"; // Import the centralized CSS file
import UserSearchSelect from "../components/UserSearchSelect";

const AddBenefit = () => {
  const [form, setForm] = useState({
    clientId: "",
    clientName: "",
    bdaId: "",
    planName: "",
    investmentAmount: "",
    oneTimeIncome: "",
    investmentDate: "",
    remarks: "",
  });
  const [selectedUser, setSelectedUser] = useState(null);

  const navigate = useNavigate();

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleBdaSelect = (user) => {
    setForm((prev) => ({
      ...prev,
      bdaId: user.bdaId,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.bdaId) {
  alert("Please select a BDA before saving.");
  return;
}

    await addDoc(collection(db, "benefits"), {
      ...form,
      investmentAmount: Number(form.investmentAmount),
      oneTimeIncome: Number(form.oneTimeIncome),
      investmentDate: Timestamp.fromDate(new Date(form.investmentDate)),
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now(),
    });
    navigate("/admin/other-benefits");
  };

  return (
    <div className="card">
      <h3>Add Other Benefit</h3>
      <UserSearchSelect onUserSelect={handleBdaSelect} />

      <form onSubmit={handleSubmit} className="benefit-form">
        <div className="benefit-grid">
          <div className="form-group">
            <label>BDA ID</label>
            <input value={form.bdaId} disabled />
          </div>
          <div className="form-group">
            <label>Client ID</label>
            <input name="clientId" onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label>Client Name</label>
            <input name="clientName" onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label>Plan Name</label>
            <input name="planName" onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label>Investment Date</label>
            <input
              type="date"
              name="investmentDate"
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Investment Amount</label>
            <input
              type="number"
              name="investmentAmount"
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>One-Time Income</label>
            <input
              type="number"
              name="oneTimeIncome"
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group ">
            <label>Remarks</label>
            <textarea name="remarks" rows="3" onChange={handleChange} />
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="admin-button primary">
            Save Benefit
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddBenefit;
